import { useEffect, useState } from "react";

import { ArrowUp } from "react-feather";

import * as Styles from "./styles";

const ScrollToTop = () => {
  const [makeACtive, setMakeActive] = useState(false);

  const handleCroll = () => {
    const scrolled = window
      ? window.pageYOffset
      : document.documentElement.scrollTop;

    if (scrolled > 300) {
      setMakeActive(true);
    } else if (scrolled <= 300) {
      setMakeActive(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleCroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleCroll);
    };
  }, []);

  const backToTop = (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <Styles.Container
      type="button"
      onClick={backToTop}
      active={makeACtive}
      aria-label="Back to top"
      tabIndex={makeACtive ? 0 : -1}
    >
      <ArrowUp aria-hidden="true" />
    </Styles.Container>
  );
};

export default ScrollToTop;
